<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm9 class="intro-guide px-4" v-if="false && !profile.profile_commenced">
        <p>Please take a moment to update your profile. If you choose to skip this step for now, we'll remind you to
          update your profile the next time you login.</p>
        <div class="">
          <button class="ml-0 v-btn theme--light primary" v-on:click="skipProfile">Skip this and go to My
            Dashboard</button>
        </div>
        <div class="spacer"></div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="from">
      <v-flex xs-12 sm-12 md-12 mb-4>
        <router-link class='ml-0 back-button' :to="from.fullPath" color="primary"><v-icon size="16" color="primary">fa
            fa-arrow-left</v-icon> Return to Previous Page</router-link>
      </v-flex>
    </v-layout>
    <v-layout row wrap>

      <v-flex md6 class="pr-5 mt-4">
        <v-flex>
          <div>
            <h3 class=" mb-0">Personal Information</h3>
            <hr class="thick mt-2 mb-4" />
          </div>
          <div>
            <v-form ref="editProfileForm" v-model="form.valid">
              <v-select label="Title*" v-model="profile.title" :items="titles" :rules="form.title"></v-select>
              <v-text-field label="First Name*" v-model="profile.first_name" :rules="form.first_name"></v-text-field>
              <v-text-field label="Last Name*" v-model="profile.last_name" :rules="form.last_name"></v-text-field>
              <v-text-field label="Display Name*" v-model="profile.display_name" :rules="form.display_name"
                hint="This is what other users will see in the system."></v-text-field>
              <v-text-field label="Email*" v-model="profile.email" :rules="form.email"></v-text-field>

              <h4 class="mt-2 mb-3">Profile Photo</h4>
              <v-layout row>
                <v-flex lg4 md12>
                  <v-avatar class="secondary mx-auto" size="100px">
                    <v-progress-circular indeterminate color="primary" v-if="profilePhotoLoading"></v-progress-circular>
                    <img :src="profilePhotoSrc" v-else-if="hasProfilePhoto" />
                    <span class="white--text headline" style="font-size:40px !important;"
                      v-else>{{ profile.initials }}</span>
                  </v-avatar>
                </v-flex>
                <v-flex lg6 md12 fill-height>
                  <AmazePhotoUpload label="Change Photo" :linkTrigger=true accept="png,jpg,gif"
                    v-on:formData="onPhotoChange" />
                </v-flex>
              </v-layout>

              <v-layout row mt-4>
                <v-btn color="primary" @click.enter="saveProfile" class='ml-0'>Save Changes</v-btn>
                <v-btn color="gray" to='/profile'>Cancel</v-btn>
              </v-layout>

            </v-form>
          </div>
        </v-flex>
      </v-flex>

      <v-flex v-if="false" md4 class="pr-5 mt-4">
        <div>
          <h3 class=" mb-0">Work Information</h3>
          <hr class="thick mt-2 mb-4" />
        </div>
        <div>
          <work-fields :profile="profile.meta"></work-fields>
          <v-layout row>
            <v-btn color="primary" @click.enter="saveProfile" class='ml-0'>Save Changes</v-btn>
            <v-btn color="gray" to='/profile'>Cancel</v-btn>
          </v-layout>
        </div>
      </v-flex>

      <v-flex md6 class="pr-5 mt-4">
        <div id="PasswordReset">
          <div>
            <h3 class=''>Change Password</h3>
            <hr class="thick mt-2 mb-2" />
          </div>
          <div>
            <p class='mb-3'>Passwords must be at least 8 characters, contain at least one upper case letter and at least
              one digit.</p>
            <v-form ref="editPasswordForm" v-model="passwordForm.valid">
              <v-text-field password label="Original Password*" v-model='original_password'
                :rules="passwordForm.original_password" :append-icon="show1 ? 'visibility_off' : 'visibility'"
                :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" />
              <v-text-field password label="New Password*" v-model='new_password' :rules="passwordForm.new_password"
                :type="show2 ? 'text' : 'password'" @click:append="show2 = !show2" />
              <v-text-field password label="Confirm Password*" v-model='confirm_password'
                :rules="passwordForm.confirm_password" :type="show3 ? 'text' : 'password'"
                @click:append="show3 = !show3" />
              <v-btn class='ml-0' color="primary" @click="savePassword()">Reset Password</v-btn>
              <v-btn color="gray" to='/profile'>Cancel</v-btn>
            </v-form>
          </div>
        </div>
      </v-flex>

      <v-flex xs12 class="mt-4">
        <div>
          <h3 class="mb-0">Group Activity Notification Email Settings</h3>
          <hr class="thick mt-2 mb-2" />
        </div>

        <div>
          <v-layout>
            <v-flex xs12 lg8>
              <p class="mb-3">Group activity notification emails help you stay informed of the latest updates in the groups you have joined. Use the switch below to enable or disable group activity notification emails. If enabled, you can use the <em>Group-Specific Activity Notification Email Settings</em> to fine-tune your preferences. <strong>Changes in this section are automatically saved.</strong>
              </p>
            </v-flex>
          </v-layout>
        </div>

        <div id="GroupEmailNotifications">
          <v-layout my-2>
            <v-flex xs12 mb-4 class="user-settings">
              <v-switch label="Enable group activity notification emails." v-model="userSettingsForm.allowActivityEmail"
                :messages="userSettingsForm.allowActivityEmail ? 'You may receive group activity notification emails from the groups you have joined.' : 'All group activity notification emails are disabled.'"
                color="secondary" class="mt-2 mb-0 pb-0 email-switch" @change="updateEmailSettings">
              </v-switch>
            </v-flex>
          </v-layout>
          <v-container grid-list-md align-content-start fluid v-show="userSettingsForm.allowActivityEmail" v-if="groupEmailPreferences && groupEmailPreferences.length > 0" ma-0 pa-0>
            <h4 class="mb-2">Group-Specific Activity Notification Email Settings</h4>
            <p class="mb-2">These settings allow you to adjust your personal activity notification email preferences in each group you have joined.</p>
            <v-layout row wrap>
              <v-flex xs12 md5 mr-3 my-2 v-for="s in groupEmailPreferences" :key="s">
                <v-card class="group-notification-settings pa-3 fill-height">
                  <v-card-title class="title ma-0 pa-0">
                    <h6 class="title ma-0 pa-0"><small><strong>{{ s.name }}</strong></small></h6>
                  </v-card-title>
                  <v-card-actions>
                    <AmazeActivityEmailControls
                    :nofetch="true"
                    :settings="s"
                    ></AmazeActivityEmailControls>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";

input[type="file"] {
  position: absolute;
  left: -99999px;
}

.user-settings {
  .email-switch {
    min-width: 240px;
  }
}
</style>

<script>
import MemberService from "@/services/MemberService";
import AmazeSubnav from "@/components/Widgets/AmazeSubnav";
import AmazePhotoUpload from "@/components/Widgets/AmazePhotoUpload";
import WorkFields from '@/components/Pages/Profile/Edit/Fields/Work';
import AmazeActivityEmailControls from '@/components/Widgets/AmazeActivityEmailControls';

export default {
  components: {
    AmazeSubnav,
    AmazePhotoUpload,
    WorkFields,
    AmazeActivityEmailControls
  },
  data() {
    return {
      from: null,
      options: {
        url: process.env.VUE_APP_API_BASE + "/users/profile_photo",
        paramName: "file"
      },
      profile: {},
      schools: [],
      districts: [],
      states: [],
      titles: ["None", "Ms.", "Mrs.", "Mr.", "Dr."],
      displayName: null,
      flagRoleNames: null,
      hasProfilePhoto: false,
      profilePhotoLoading: false,
      original_password: "",
      new_password: "",
      confirm_password: "",
      show1: false,
      show2: false,
      show3: false,
      navItems: [
        { text: "Profile", key: "profile", href: "/profile/edit" },
        { text: "Change Password", key: "password", href: "/profile/edit" },
        { text: "Notification Emails", key: "email", href: "/profile/edit" }
      ],
      form: {
        valid: false,
        title: [v => !!v || "Please enter your title "],
        first_name: [v => !!v || "Please enter your first name "],
        last_name: [v => !!v || "Please enter your last name"],
        email: [v => !!v || "Please enter your email address"],
        display_name: [
          v =>
            !!v || "Please enter how you'd like your name to appear in Amaze."
        ]
      },
      passwordForm: {
        valid: false,
        original_password: [v => !!v || "Please enter your current password. "],
        new_password: [
          v => /[0-9]/.test(v) || "Passwords have at least one digit",
          v => /[A-Z]/.test(v) || "Passwords have at least one upper case letter",
          v => v.length >= 8 || "Passwords must be 8 or more characters"
        ],
        confirm_password: [
          v => v === this.new_password || "Passwords do not match"
        ]
      },
      userSettingsForm: {
        allowActivityEmail: true
      },
      groupEmailPreferences: []
    }
  },
  methods: {
    skipProfile() {
      this.$router.push({ path: "/dashboard" });
    },
    saveProfile() {
      if (this.$refs.editProfileForm.validate()) {
        var formData = {
          first_name: this.profile.first_name,
          last_name: this.profile.last_name,
          title: this.profile.title,
          display_name: this.profile.display_name,
          meta: this.profile.meta,
          profile_commenced: true
        };
        this.$http.put("users/" + this.profile.id, formData).then(
          response => {
            this.profile.profile_commenced = true;
            this.$store.commit("updateMessage", {
              message: "Profile saved.",
              snackbar: true
            });
            this.$router.push({ path: "/profile/" + this.profile.id });
          },
          response => {
            console.log("Error saving profile");
            this.$store.commit("updateMessage", {
              message: "We've encountered an error and are unable to save your profile at this time.",
              snackbar: true
            });
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message:
            "Nice try, but some required information is missing. Give it another go!",
          snackbar: true
        });
      }
    },
    getProfile(id) {
      return MemberService.getProfile(id).then(
        response => {
          this.profile = response;

          if (!this.profile.meta) {
            this.profile.meta = {};
          }

          this.setDisplayName(this.profile);
          this.setFlagRoleNames(this.profile);
          this.setSettingsEmails(this.profile);
          this.setGroupEmailPreferences(this.profile);

          this.hasProfilePhoto = this.profile.profile_photo.hasOwnProperty(
            "large"
          );
          if (this.hasProfilePhoto) {
            this.profilePhotoSrc =
              this.profile.profile_photo.large + "?" + new Date().getTime();
          }
          this.$store.commit("loading", { loading: false });
        },
        response => {
          console.error("[error] getProfile");
        }
      );
    },
    /**
     * This generates the activity email settings for each group
     * the user is a member of. If settings already exist for
     * the user-group combination, we'll use that. However, if the
     * user doesn't currently have settings for a group, we will
     * generate the default settings (consent=yes, aggregate=no).
     */
    getGroupEmailPreferences(profile) {
      let settings = [];

      let entries = profile && profile.activityemailsettings
        ? profile.activityemailsettings
        : [];

      // Use group memberships as the basis for which settings to display
      // to ensure that there's a settings panel for each group the
      // user is a member of.
      for (let index in profile.groups) {
        let group = profile.groups[index];
        let entry = entries.filter(function (e) {
          return e.group_id == group.id;
        }).pop();

        // This injects the default settings b/c we did not find
        // existing settings for this user-group combination.
        if (!entry || entry.length < 1) {
          entry = {
            consent: true,
            aggregate: false
          };
        }

        entry = Object.assign(entry, group);
        entry['user_id'] = profile.id;
        entry['group_id'] = group.id;

        settings.push(entry);
      }

      return settings;
    },
    setGroupEmailPreferences(profile) {
      let settings = this.getGroupEmailPreferences(profile);

      // Sort settings by group name.
      settings = settings && settings.length ? settings.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }) : [];

      this.groupEmailPreferences = settings;
    },
    getProfilePhoto(id) {
      return MemberService.getProfile(id).then(
        response => {
          this.profile.profile_photo = response.profile_photo;
          this.hasProfilePhoto = this.profile.profile_photo.hasOwnProperty(
            "large"
          );
          if (this.hasProfilePhoto) {
            this.profilePhotoSrc =
              this.profile.profile_photo.large + "?" + new Date().getTime();
          }
        },
        response => {
          console.error("[error] getProfile");
        }
      );
    },
    onPhotoChange(formData) {
      this.hasProfilePhoto = false;
      this.profilePhotoLoading = true;
      this.$http.post("users/profile_photo", formData).then(
        response => {
          this.profilePhotoLoading = false;
          this.$store.commit("updateMessage", {
            message: "Profile photo saved.",
            snackbar: true
          });
          this.getProfilePhoto(this.$auth.user().id);
        },
        response => {
          this.profilePhotoLoading = false;
          this.$store.commit("updateMessage", {
            message: "Error saving profile photo.",
            snackbar: true
          });
          console.log("Error saving profile photo.");
        }
      );
    },
    setDisplayName(profile) {
      this.displayName = MemberService.getDisplayName(profile);
    },
    setFlagRoleNames(profile) {
      this.flagRoleNames = MemberService.getFriendlyFlagNames(profile);
    },
    setSettingsEmails(profile) {
      this.userSettingsForm.allowActivityEmail = profile.allow_activity_email;
    },
    savePassword() {
      if (this.$refs.editPasswordForm.validate()) {
        let formData = {
          old: this.original_password,
          password: this.new_password,
          password_confirmation: this.confirm_password
        };
        this.$http.post("password/update", formData).then(
          response => {
            this.$store.commit("updateMessage", {
              message: "Your password has been updated.",
              snackbar: true
            });
          },
          response => {
            this.$store.commit("updateMessage", {
              message:
                "We were not able to update the password. " +
                response.data.password[0] +
                " Please review the form and try again.",
              snackbar: true
            });
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message:
            "Nice try, but some required information is missing. Give it another go!",
          snackbar: true
        });
      }
    },
    updateEmailSettings() {
      MemberService.updateEmailSettings(this.userSettingsForm).then(
        response => {
          this.$store.commit("updateMessage", {
            message: "Your email preferences have been updated.",
            snackbar: true
          });
        },
        response => {
          console.error("[profile:updateEmailSetting] error updating email activity settings.");
        }
      );
    }
  },
  mounted() {
    this.$http.get("schools/list").then(
      response => {
        this.schools = response.body.data;
      },
      response => {
        console.log("Error getting schools.");
      }
    );
    this.$http.get("districts/list").then(
      response => {
        this.districts = response.body.data;
      },
      response => {
        console.log("Error getting districts.");
      }
    );

    const user = this.$auth.user();
    this.getProfile(user.id);
  },
  activated() {
    const user = this.$auth.user();
    this.getProfile(user.id);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from;
    });
  },
  created() {
    this.$store.commit("loading", { loading: true });

    const user = this.$auth.user();
    this.getProfile(user.id);
  }
};
</script>
